import React from 'react';
import styled from '@emotion/styled';
import { style } from 'framer-motion/client';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.div`
  width: 100%;
  padding: 40px;
  background-color: #FAF7F3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Courier New', monospace;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: unset;
  }

  @media (max-width: 768px) {
   padding-bottom:20px!important;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  margin: 0;
  font-weight: 600;
`;

const Subtitle = styled.p`
  font-size: 14px;
  margin: 0;
  font-style: italic;
`;

const Nav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;

  @media (max-width: 768px) {
    margin-top:20px;
    gap: 10px;
  }
`;

const NavLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: black;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 14px;
  background-color: black;
`;

const Header = () => {
  const navigate = useNavigate();
  return (
    <HeaderContainer>
      <div>
        <Title>GRAHAM THORBURN</Title>
        <Subtitle>Director, Producer, Writer, Teacher</Subtitle>
      </div>
      <Nav>
        <NavLink onClick={()=> navigate('/')}>HOME.</NavLink>
        <Divider />
        <NavLink href="#">CONNECT.</NavLink>
        <Divider />
        <NavLink className="border" href="#">SCRIPTORIUM.</NavLink>
      </Nav>
    </HeaderContainer>
  );
};

export default Header; 